import React, { ReactElement } from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export default function CollapseIcon(props: SvgIconProps): ReactElement {
  return (
    <SvgIcon {...props}>
      <g rotate={60} transform="rotate(180, 7, 8)">
        <path d="M8,2,6.6,3.4,11.2,8,6.6,12.6,8,14l6-6ZM0,16H2V0H0Z" />
      </g>
    </SvgIcon>
  );
}
